import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import HddOutlinedSvg from "@ant-design/icons-svg/es/asn/HddOutlined";
import AntdIcon from "../components/AntdIcon";
var HddOutlined = function HddOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HddOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  HddOutlined.displayName = 'HddOutlined';
}
export default /*#__PURE__*/React.forwardRef(HddOutlined);